<template>
  <div class="animated fadeIn">

    <b-row>
      <b-col lg="12">
        <b-card v-if="tieneAcceso === false">
          <div slot="header">
            <strong>Actividades de la Tarea</strong>
          </div>
          <b-row>
            <b-col lg="12">
              <p>Acceso restringido</p>
            </b-col>
          </b-row>
        </b-card>
        <b-card v-if="tieneAcceso === true">
          <div slot="header">
            <strong>Actividades de la Tarea ({{ this.desc_gsaproced }}) </strong>
          </div>
          <b-row>
            <b-col lg="6">
              <b-button type="primary" variant="primary" @click="agregarActividad">
                <i class="fa fa-plus"></i> Agregar Actividad
              </b-button>
              
            </b-col>
            
            <b-col lg="6">
              <b-form-group label label-for="filtroActividad">
                <b-form-input
                  id="filtroActividad"
                  type="text"
                  placeholder="Filtrar Actividades"
                  v-model="filters[0].value"
                ></b-form-input>
              </b-form-group>
            </b-col>
          </b-row>
          <br>
          <b-row>
            <b-col lg="12">
              <data-tables
                :data="data"
                :current-page.sync="pagina"
                :table-props="tableProps"
                :filters="filters"
                :page-size="10"
                :pagination-props="{ background: true, pageSizes: [10, 20, 50] }"
                layout="table"
              >
                <el-table-column
                  v-for="title in titles"
                  :prop="title.prop"
                  :label="title.label"
                  :key="title.label"
                  sortable="custom"
                  :formatter="formatter"
                ></el-table-column>

                <el-table-column label="Acciones" min-width="100px">
                  <template slot-scope="scope">
                    <el-button
                      v-for="button in customButtonsForRow(scope.row)"
                      :key="button.name"
                      type="text"
                      @click="button.handler"
                    >
                      <i v-bind:class="button.icon"></i>
                      {{ button.name }}
                    </el-button>
                  </template>
                </el-table-column>
              </data-tables>
            </b-col>
          </b-row>
        </b-card>
      </b-col>
    </b-row>

    <editar-actividad ref="refEditarActividad" @actualizaActividades="buscarActividad()"></editar-actividad>
    
    <b-modal
      title="Advertencia"
      cancel-title="Cancelar"
      ok-title="Desactivar"
      class="modal-warning"
      v-model="modalEliminarActividad"
      @ok="eliminarActividad();"
      @cancel="modalEliminarActividad = false"
    >¿Está seguro que quiere desactivar esta actividad?</b-modal>

    <b-modal
      title="Advertencia"
      cancel-title="Cancelar"
      ok-title="Activar"
      class="modal-warning"
      v-model="modalActivarActividad"
      @ok="activarActividad();"
      @cancel="modalActivarActividad = false"
    >¿Está seguro que quiere activar esta actividad?</b-modal>
    <!--
    <b-row>
      <b-col lg="12">
        <b-card>
          <div slot="header">
            <strong>Estados de la Tarea ({{ this.desc_gsaproced }}) </strong>
          </div>
          <b-row>
            <b-col lg="6">
              <b-button type="primary" variant="primary" @click="agregarEstado">
                <i class="fa fa-plus"></i> Agregar Estado
              </b-button>
            </b-col>
            <b-col lg="6">
              <b-form-group label label-for="filtroEstado">
                <b-form-input
                  id="filtroEstado"
                  type="text"
                  placeholder="Filtrar Estados"
                  v-model="filtersEstado[0].value"
                ></b-form-input>
              </b-form-group>
            </b-col>
          </b-row>
          <br>
          <b-row>
            <b-col lg="12">
              <data-tables
                :data="dataEstado"
                :current-page.sync="pagina"
                :table-props="tableProps"
                :filters="filtersEstado"
                :page-size="10"
                :pagination-props="{ background: true, pageSizes: [10, 20, 50] }"
                layout="table"
              >
                <el-table-column
                  v-for="title in titlesEstado"
                  :prop="title.prop"
                  :label="title.label"
                  :key="title.label"
                  sortable="custom"
                  :formatter="formatter"
                ></el-table-column>

                <el-table-column label="Acciones" min-width="100px">
                  <template slot-scope="scope">
                    <el-button
                      v-for="button in customButtonsForRowEstado(scope.row)"
                      :key="button.name"
                      type="text"
                      @click="button.handler"
                    >
                      <i v-bind:class="button.icon"></i>
                      {{ button.name }}
                    </el-button>
                  </template>
                </el-table-column>
              </data-tables>
            </b-col>
          </b-row>
        </b-card>
      </b-col>
    </b-row>
    -->
    <editar-estado ref="refEditarEstado" @actualizaEstados="buscarEstado()"></editar-estado>

    <b-modal
      title="Advertencia"
      cancel-title="Cancelar"
      ok-title="Desactivar"
      class="modal-warning"
      v-model="modalEliminarEstado"
      @ok="eliminarEstado();"
      @cancel="modalEliminarEstado = false"
    >¿Está seguro que quiere desactivar este estado?</b-modal>

    <b-modal
      title="Advertencia"
      cancel-title="Cancelar"
      ok-title="Activar"
      class="modal-warning"
      v-model="modalActivarEstado"
      @ok="activarEstado();"
      @cancel="modalActivarEstado = false"
    >¿Está seguro que quiere activar este estado?</b-modal>

    <b-row>
      <b-col lg="12">
        <b-card v-if="tieneAcceso === true">
          <div slot="header">
            <strong>Dependencia de Actividades en la Tarea ({{ this.desc_gsaproced }}) </strong>
          </div>
          <b-row>
            <b-col lg="6">
              <b-button type="primary" variant="primary" @click="agregarDependencia">
                <i class="fa fa-plus"></i> Agregar Dependencia
              </b-button>
              
            </b-col>
            
            <b-col lg="6">
              <b-form-group label label-for="filtroDependencia">
                <b-form-input
                  id="filtroDependencia"
                  type="text"
                  placeholder="Filtrar Dependencias"
                  v-model="filtersDependencia[0].value"
                ></b-form-input>
              </b-form-group>
            </b-col>
          </b-row>
          <br>
          <b-row>
            <b-col lg="12">
              <data-tables
                :data="dataDependencia"
                :current-page.sync="pagina"
                :table-props="tableProps"
                :filters="filtersDependencia"
                :page-size="10"
                :pagination-props="{ background: true, pageSizes: [10, 20, 50] }"
                layout="table"
              >
                <el-table-column
                  v-for="title in titlesDependencia"
                  :prop="title.prop"
                  :label="title.label"
                  :key="title.label"
                  sortable="custom"
                  :formatter="formatter"
                ></el-table-column>

                <el-table-column label="Acciones" min-width="100px">
                  <template slot-scope="scope">
                    <el-button
                      v-for="button in customButtonsForRowDependencia(scope.row)"
                      :key="button.name"
                      type="text"
                      @click="button.handler"
                    >
                      <i v-bind:class="button.icon"></i>
                      {{ button.name }}
                    </el-button>
                  </template>
                </el-table-column>
              </data-tables>
            </b-col>
          </b-row>
        </b-card>
      </b-col>
    </b-row>

    <editar-dependencia ref="refEditarDependencia" @actualizaDependencias="buscarDependencia()"></editar-dependencia>

    <b-modal
      title="Advertencia"
      cancel-title="Cancelar"
      ok-title="Desactivar"
      class="modal-warning"
      v-model="modalEliminarDependencia"
      @ok="eliminarDependecia();"
      @cancel="modalEliminarDependencia = false"
    >¿Está seguro que quiere desactivar esta Dependencia?</b-modal>

    <b-modal
      title="Advertencia"
      cancel-title="Cancelar"
      ok-title="Activar"
      class="modal-warning"
      v-model="modalActivarDependencia"
      @ok="activarDependencia();"
      @cancel="modalActivarDependencia = false"
    >¿Está seguro que quiere activar esta Dependencia?</b-modal>

  </div>
</template>
<script>
import { Switch as cSwitch } from "@coreui/vue";
import axios from "axios";
import { tablasMixin } from "@/components/mixins/tablasMixin";
import apiActividades from "@/components/services/apiActividades";
import { globalesMixin } from "@/components/mixins/globalesMixin";
import EditarActividad from "./EditarActividad";
import EditarEstado from "./EditarEstado";
import EditarDependencia from "./EditarDependencia";

export default {
  name: "Configuracion",
  mixins: [tablasMixin, globalesMixin],
  components: {
    cSwitch,
    EditarActividad,
    EditarEstado,
    EditarDependencia
  },
  data: function() {
    return {
      tieneAcceso: true,

      gsaproced: "",
      desc_gsaproced: "",

      modalEliminarDependencia: false,
      modalActivarDependencia: false,
      modalAgregarDependencia: false,
      dependenciaSelected: null,

      modalEliminarActividad: false,
      modalActivarActividad: false,
      modalAgregarActividad: false,
      actividadSelected: null,
      
      modalEliminarEstado: false,
      modalActivarEstado: false,
      modalAgregarEstado: false,
      estadoSelected: null,
      
      busqueda: "",
      pagina: 1,
      paginaAnterior: 1,
      labelIcon: {
        dataOn: "\u2713",
        dataOff: "\u2715"
      },
      datosFormulario: [],
      datosFormularioEstado: [],
      data: [],
      dataEstado: [],
      dataDependencia: [],
      titles: [
        /*
        {
          prop: "gsanombre",
          label: "Nombre"
        },
        */
        {
          prop: "gsadescripcion",
          label: "Descripción"
        },
        {
          prop: "desc_automatica",
          label: "Automatica"
        },
        /*
        {
          prop: "gsasecuencia",
          label: "Secuencia"
        },        
        {
          prop: "gsapantalla",
          label: "Pantalla"
        },
        {
          prop: "gsaproceso",
          label: "Proceso"
        },
        {
          prop: "desc_gsaprocestado",
          label: "Estado Instanciado"
        },
        */
        {
          prop: "desc_frecuencia",
          label: "Frecuencia"
        },
        {
          prop: "gsadiaprogramado",
          label: "Día Programado"
        },
        {
          prop: "desc_gsaplazo",
          label: "Plazo"
        },
        {
          prop: "desc_gspiniactivi",
          label: "Actividad Inicial"
        },
        {
          prop: "desc_activo",
          label: "Estado"
        }
      ],
      filters: [
        {
          prop: [
            /*
            "gsanombre",
            */
            "gsadescripcion",
            "desc_automatica",
            /*
            "gsasecuencia",
            "gsapantalla",
            "gsaproceso",
            "desc_gsaprocestado",
            */
            "desc_frecuencia",
            "gsadiaprogramado",
            "desc_gsaplazo",
            "desc_gspiniactivi",
            "desc_activo",
          ],
          value: ""
        }
      ],
      titlesEstado: [
        {
          prop: "gpecodigo",
          label: "Nombre"
        },
        {
          prop: "gpedescripcion",
          label: "Descripción"
        },
        {
          prop: "gpeefecto",
          label: "Efecto"
        },
        /*
        {
          prop: "gpesecuencia",
          label: "Secuencia"
        },
        */
       {
          prop: "desc_gspiniestado",
          label: "Estado Inicial"
        },
        {
          prop: "desc_activo",
          label: "Estado"
        }
      ],
      filtersEstado: [
        {
          prop: [
            "gpecodigo",
            "gpedescripcion",
            "gpeefecto",
            /*
            "gpesecuencia",
            */
            "desc_gspiniestado",
            "desc_activo"
          ],
          value: ""
        }
      ],
      titlesDependencia: [
        {
          prop: "desc_actividad",
          label: "Actividad"
        },
        {
          prop: "desc_requis",
          label: "Actividad Requerida"
        },
        {
          prop: "desc_activo",
          label: "Estado"
        }
      ],
      filtersDependencia: [
        {
          prop: [
            "desc_actividad",
            "desc_requis",
            "desc_activo"
          ],
          value: ""
        }
      ]
    };
  },
  methods: {
    
    customButtonsForRow(row) {
      if (row.gsaactivo === 0) {
        return [
          {
            name: " Activar",
            icon: "fa fa-plus",
            type: "success",
            handler: _ => {
              this.$session.start();
              this.modalActivarActividad = true;
              this.actividadSelected = row.gsanombre;
            }
          }
        ];
      } else {
        return [
          /*
          {
            name: " Configurar",
            icon: "fa fa-cogs",
            type: "primary",
            handler: _ => {
              this.configurar(this.gsaproced, row.gsanombre);
            }
          },*/
          {
            name: " Modificar",
            icon: "fa fa-pencil",
            type: "primary",
            handler: _ => {
              this.$refs.refEditarActividad.modalEditarActividad = true;
              this.$refs.refEditarActividad.visible = true;
              this.$refs.refEditarActividad.obtenerActividad(
                this.$session.get("mail"),
                this.$session.get("usuarioInterno"),
                this.gsaproced,
                row.gsanombre,
                "MOD"
              );
            }
          },
          {
            name: " Desactivar",
            icon: "fa fa-trash",
            type: "danger",
            handler: _ => {
              this.$session.start();
              this.modalEliminarActividad = true;
              this.actividadSelected = row.gsanombre;
            }
          }
        ];
      }
    },

    customButtonsForRowEstado(row) {
      if (row.gpeactivo === 0) {
        return [
          {
            name: " Activar",
            icon: "fa fa-plus",
            type: "success",
            handler: _ => {
              this.$session.start();
              this.modalActivarEstado = true;
              this.estadoSelected = row.gpecodigo;
            }
          }
        ];
      } else {
        return [
          {
            name: " Modificar",
            icon: "fa fa-pencil",
            type: "primary",
            handler: _ => {
              this.$refs.refEditarEstado.modalEditarEstado = true;
              this.$refs.refEditarEstado.visible = true;
              this.$refs.refEditarEstado.obtenerEstado(
                this.$session.get("mail"),
                this.$session.get("usuarioInterno"),
                this.gsaproced,
                row.gpecodigo,
                "MOD"
              );
            }
          },
          {
            name: " Desactivar",
            icon: "fa fa-trash",
            type: "danger",
            handler: _ => {
              this.$session.start();
              this.modalEliminarEstado = true;
              this.estadoSelected = row.gpecodigo;
            }
          }
        ];
      }
    },

    customButtonsForRowDependencia(row) {
      if (row.graactivo === 0) {
        return [
          {
            name: " Activar",
            icon: "fa fa-plus",
            type: "success",
            handler: _ => {
              this.$session.start();
              this.modalActivarDependencia = true;
              this.dependenciaSelected = row.gracodigo;
            }
          }
        ];
      } else {
        return [
          {
            name: " Modificar",
            icon: "fa fa-pencil",
            type: "primary",
            handler: _ => {
              this.$refs.refEditarDependencia.modalEditarDependencia = true;
              this.$refs.refEditarDependencia.visible = true;
              
              this.$refs.refEditarDependencia.obtenerDependencia(
                this.$session.get("mail"),
                this.$session.get("usuarioInterno"),
                this.gsaproced,
                row.gracodigo,
                "MOD"
              );
            }
          },
          {
            name: " Desactivar",
            icon: "fa fa-trash",
            type: "danger",
            handler: _ => {
              this.$session.start();
              this.modalEliminarDependencia = true;
              this.dependenciaSelected = row.gracodigo;
            }
          }
        ];
      }
    },
    
    buscarActividad(gsanombre) {
      this.$Progress.start();
      return apiActividades
        .buscarActividad(
          this.$session.get("mail"),
          this.$session.get("usuarioInterno"),
          this.gsaproced,
          gsanombre,
          "REC"
        )
        .then(response => {
          response.data = this.keysMinuscula(response.data);

          //Bloqueo usuario no valido
          if (response.data.args_out.usuarioval == 's'){
            this.tieneAcceso = true;
          }else{
            this.tieneAcceso = false;
          }

          this.data = response.data.res;
          this.pagina = this.paginaAnterior;
          //this.$router.push({ path: "configuracion" });
          this.$Progress.finish();
        })
        .catch(error => {
          this.crearNotificacion("Error de sistema", error, "error");
        });
    },

    buscarEstado(gpecodigo) {
      this.$Progress.start();
      return apiActividades
        .buscarEstado(
          this.$session.get("mail"),
          this.$session.get("usuarioInterno"),
          this.gsaproced,
          gpecodigo,
          "REC"
        )
        .then(response => {
          response.data = this.keysMinuscula(response.data);
          this.dataEstado = response.data.res;
          this.pagina = this.paginaAnterior;
          //this.$router.push({ path: "configuracion" });
          this.$Progress.finish();
        })
        .catch(error => {
          this.crearNotificacion("Error de sistema", error, "error");
        });
    },

    buscarDependencia(gracodigo) {
      this.$Progress.start();
      return apiActividades
        .buscarDependencia(
          this.$session.get("mail"),
          this.$session.get("usuarioInterno"),
          this.gsaproced,
          this.gracodigo,
          "REC"
        )
        .then(response => {
          response.data = this.keysMinuscula(response.data);
          this.dataDependencia = response.data.res;
          this.pagina = this.paginaAnterior;
          this.$Progress.finish();
        })
        .catch(error => {
          this.crearNotificacion("Error de sistema", error, "error");
        });
    },
    
    formatter(row, column) {
      if (column.property == "prifmodif" && row[column.property]) {
        return this.$moment(row[column.property]).format("DD-MM-YYYY");
      } else if (column.property == "pricodnum" && row[column.property]) {
        column.align = "is-right";
        return this.$numeral(row[column.property]).format("0");
      } else {
        return row[column.property];
      }
    },
    
    agregarActividad() {
      this.$refs.refEditarActividad.modalAgregarActividad = true;
      this.$refs.refEditarActividad.visible = true;
      this.$refs.refEditarActividad.pre_insertar(
        this.$session.get("mail"),
        this.$session.get("usuarioInterno"),
        this.gsaproced,
        ""
      );
    },

    agregarEstado() {
      this.$refs.refEditarEstado.modalAgregarEstado = true;
      this.$refs.refEditarEstado.visible = true;
      this.$refs.refEditarEstado.pre_insertar(
        this.$session.get("mail"),
        this.$session.get("usuarioInterno"),
        this.gpecodigo,
        ""
      );
    },

    agregarDependencia() {
      this.$refs.refEditarDependencia.modalAgregarDependencia = true;
      this.$refs.refEditarDependencia.visible = true;
      this.$refs.refEditarDependencia.pre_insertarDependencia(
        this.$session.get("mail"),
        this.$session.get("usuarioInterno"),
        this.gsaproced,
        ""
      );
    },

    eliminarActividad() {
      event.preventDefault();
      this.$Progress.start();
      

      return apiActividades
        .eliminarActividad(
          this.$session.get("mail"),
          this.$session.get("usuarioInterno"),
          this.gsaproced,
          this.actividadSelected
        )
        .then(response => {
          let errs = [];
          errs.push(response.data.festado);

          this.mensajeToastr({
            title: response.data.festado.resultado.titulo,
            //message: this.crearError(response.data.festado, "gsanombre"),
            message: this.cargaErrores(errs),
            type: response.data.festado.resultado.estado,
            timeout: 6000
          });
          if (response.data.festado.resultado.estado != "error") {
            this.buscarActividad("");
            this.modalEliminarActividad = false;
          }
          this.$Progress.finish();
        })
        .catch(error => {
          this.crearNotificacion("Error de sistema", error, "error");
        });
    },

    eliminarEstado() {
      event.preventDefault();
      this.$Progress.start();
      return apiActividades
        .eliminarEstado(
          this.$session.get("mail"),
          this.$session.get("usuarioInterno"),
          this.gsaproced,
          this.estadoSelected
        )
        .then(response => {
          this.mensajeToastr({
            title: response.data.festado.resultado.titulo,
            message: this.crearError(response.data.festado, "gpecodigo"),
            type: response.data.festado.resultado.estado,
            timeout: 6000
          });
          if (response.data.festado.resultado.estado != "error") {
            this.buscarEstado("");
            this.modalEliminarEstado = false;
          }
          this.$Progress.finish();
        })
        .catch(error => {
          this.crearNotificacion("Error de sistema", error, "error");
        });
    },

    eliminarDependecia() {
      event.preventDefault();
      this.$Progress.start();
      return apiActividades
        .eliminarDependencia(
          this.$session.get("mail"),
          this.$session.get("usuarioInterno"),
          this.dependenciaSelected
        )
        .then(response => {
          this.mensajeToastr({
            title: response.data.festado.resultado.titulo,
            message: this.crearError(response.data.festado, "gracodigo"),
            type: response.data.festado.resultado.estado,
            timeout: 6000
          });
          if (response.data.festado.resultado.estado != "error") {
            this.buscarDependencia("");
            this.modalEliminarDependencia = false;
          }
          this.$Progress.finish();
        })
        .catch(error => {
          this.crearNotificacion("Error de sistema", error, "error");
        });
    },

    activarActividad() {
      event.preventDefault();
      this.$Progress.start();
      return apiActividades
        .activarActividad(
          this.$session.get("mail"),
          this.$session.get("usuarioInterno"),
          this.gsaproced,
          this.actividadSelected
        )
        .then(response => {
          this.mensajeToastr({
            title: response.data.festado.resultado.titulo,
            message: this.crearError(response.data.festado, "gsanombre"),
            type: response.data.festado.resultado.estado,
            timeout: 6000
          });
          if (response.data.festado.resultado.estado != "error") {
            this.buscarActividad("");
            this.modalActivarActividad = false;
          }
          this.$Progress.finish();
        })
        .catch(error => {
          this.crearNotificacion("Error de sistema", error, "error");
        });
    },

    activarEstado() {
      event.preventDefault();
      this.$Progress.start();
      return apiActividades
        .activarEstado(
          this.$session.get("mail"),
          this.$session.get("usuarioInterno"),
          this.gsaproced,
          this.estadoSelected
        )
        .then(response => {
          this.mensajeToastr({
            title: response.data.festado.resultado.titulo,
            message: this.crearError(response.data.festado, "gpecodigo"),
            type: response.data.festado.resultado.estado,
            timeout: 6000
          });
          if (response.data.festado.resultado.estado != "error") {
            this.buscarEstado("");
            this.modalActivarEstado = false;
          }
          this.$Progress.finish();
        })
        .catch(error => {
          this.crearNotificacion("Error de sistema", error, "error");
        });
    },

    activarDependencia() {
      event.preventDefault();
      this.$Progress.start();
      return apiActividades
        .activarDependencia(
          this.$session.get("mail"),
          this.$session.get("usuarioInterno"),
          this.dependenciaSelected
        )
        .then(response => {
          this.mensajeToastr({
            title: response.data.festado.resultado.titulo,
            message: this.crearError(response.data.festado, "gracodigo"),
            type: response.data.festado.resultado.estado,
            timeout: 6000
          });
          if (response.data.festado.resultado.estado != "error") {
            this.buscarDependencia("");
            this.modalActivarDependencia = false;
          }
          this.$Progress.finish();
        })
        .catch(error => {
          this.crearNotificacion("Error de sistema", error, "error");
        });
    },

    configurar(proceso, actividad){
      event.preventDefault();
      this.$Progress.start();
      this.$router.push({ path: 'resultados', query: { gspnombre: proceso, resultados: 'resultados', gsanombre: actividad }});
      this.$Progress.finish();
    }
  },
  mounted() {
    this.pagina = Number(this.$route.query.pagina);
    this.gsaproced = this.$route.query.gspnombre;
    this.desc_gsaproced = this.$route.query.desc_gspnombre;
    this.buscarActividad("");
    //this.buscarEstado("");
    this.buscarDependencia("");
  },
  watch: {
    pagina: function(nuevo, anterior) {
      this.paginaAnterior = anterior;
    }
  }
};
</script>
